import { ref, type Ref } from 'vue'
import { api } from '@/lib/api'
import { useRouter } from 'vue-router'
import { usePensionCalculations } from './usePensionCalculations'

export enum IncomeType {
  CanadianDividends = 'canadian-dividends',
  DividendsDistributions = 'dividends-distributions',
  EmpOffPen = 'emp-off-pen',
  FeesCommissions = 'fees-commissions',
  ForeignPensions = 'foreign-pensions',
  ForeignSalary = 'foreign-salary',
  MaintenancePayments = 'maintenance-payments',
  RentalIncome = 'rental-income',
  TradingProfit = 'trading-profit',
  UkDividends = 'uk-dividends',
  UsDividends = 'us-dividends',
  UntaxedStateIncome = 'untaxed-state-income',
  IrishTaxedIncome = 'irish-taxed-income',
}

const formData = ref<Partial<Record<IncomeType, any>>>({})

interface IncomeFormComposable {
  formData: Ref<Partial<Record<IncomeType, any>>>
  fetchForms: () => Promise<void>
  saveForms: () => Promise<void>
}

export function useIncomeForm(): IncomeFormComposable {
  const router = useRouter()
  const { taxback, totalTaxbackCredits } = usePensionCalculations()

  async function fetchForms(): Promise<void> {
    if (Object.keys(formData.value).length === 0) {
      try {
        const response = await api.get('/income-forms')
        formData.value = response.data
      } catch (error) {
        console.error('Failed to fetch income forms:', error)
        throw error
      }
    }
  }

  async function saveForms(): Promise<void> {
    try {
      await api.post('/income-forms', {
        'income-form': {
          declaration: formData.value,
        },
      })

      alert(
        `Congratulations! Based on the information you provided, you may be due a tax refund of €${(taxback.value).toFixed(2)}.`,
      )
      router.push('/tax-refund-options')
    } catch (error) {
      console.error('Failed to save income forms:', error)
      throw error
    }
  }

  return {
    formData,
    fetchForms,
    saveForms,
  }
}
